// Purchase discounts — shared by Purchase Order, Purchase Invoice and Non-Tax
// Purchase Invoice (screen, view and print).
//
// 1. Line-discount summary: when any line carries a discount, the bottom of the
//    document shows "Gross Amount" (qty × rate) and "Line Discount" above the
//    Subtotal (which already is after line discounts). No line discount → the
//    bottom stays exactly as before.
// 2. The order's overall (bottom) Discount follows the order onto the invoice:
//    an invoice made from the whole order gets all of it; an invoice for part
//    of the order gets that part's share (by value after line discounts).
//
// Firebase cost: nothing (works on data already on screen).

const num = (v) => Number(v) || 0;
const r2 = (v) => Math.round(v * 100) / 100;

/** { gross, lineDiscount } of lines that carry discountAmount (saved or calculated). */
export const lineDiscountSummary = (lines) => {
  let gross = 0;
  let lineDiscount = 0;
  (lines || []).forEach((l) => {
    gross += num(l.quantity) * num(l.unitPrice);
    lineDiscount += num(l.discountAmount);
  });
  return { gross: r2(gross), lineDiscount: r2(lineDiscount) };
};

/** Value of qty of an order line after its line discount. */
export const orderLineNetValue = (poLine, qty) =>
  num(qty) * num(poLine && poLine.unitPrice) * (1 - num(poLine && poLine.discountPercent) / 100);

/**
 * The order's overall Discount for a part of the order worth `partValue`
 * (after line discounts): discount × part ÷ whole order. 0 when the order has
 * no overall discount.
 */
export const orderDiscountShare = (po, partValue) => {
  const disc = num(po && po.discountAmount);
  if (!(disc > 0)) return 0;
  const whole = (po.lines || []).reduce((s, l) => s + orderLineNetValue(l, l.quantity), 0);
  if (!(whole > 0) || !(num(partValue) > 0)) return 0;
  return r2(disc * Math.min(1, num(partValue) / whole));
};
